<template>
  <div class="row">
    <loading  :active.sync="isLoading" 
              :can-cancel="false" 
              :is-full-page="true">
    </loading>
    <div class="col-md-12">
      <h4 class="title" style="margin-top:0px">{{client.company}}</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body" v-if="Object.keys(client).length > 0">
        <!-- NAME + ACTION BTN -->
        <div class="row">
          <div class="col-12 text-right">
            
            <el-button-group>
              <el-button v-if="!edition" @click="changeEdition()" type="warning" class="btn-action"><i class="fa fa-pencil"></i></el-button>
              <el-button v-if="edition" @click="cancel()" type="danger" class="btn-action"><i class="fa fa-times-circle"></i></el-button>
              <el-button v-if="edition" @click="saveClient()" type="success" class="btn-action"><i class="fa fa-save"></i></el-button>
            </el-button-group>
          </div>
        </div>
        <!-- /NAME + ACTION BTN -->
        <!-- LINK CLIENT -->
        <div class="row">
          <div class="col-lg-12 text-center d-flex justify-content-around flex-wrap mt-3">
            <span class="header_client_link">Informations</span> 
            <a :href="'https://www.societe.com/cgi-bin/search?champs='+client.siret" target="_blank" class="header_client_link">Societe.com</a> 
            <!-- <a href="#" class="header_client_link">Site du client</a>  -->
            <a :href="'https://www.google.com/maps/place/'+encodeURI(client.address+' '+client.zipcode+' '+client.city)" target="_blank" class="header_client_link">Google Maps</a> 
            <router-link :to="{ name: 'ClientCommandes', params: { cid: client.cid }}" class="header_client_link">Commandes</router-link> 
            <router-link :to="{ name: 'ClientAutre', params: { cid: client.cid }}" class="header_client_link">Autres</router-link> 
          </div>
        </div>
        <!-- /LINK CLIENT -->
        <!-- INFORMATIONS -->
        <hr data-content="Informations" class="hr-text">
        <div class="row">
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Client #</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8">{{client.cid}}</div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Négociateur :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.negociateur && !edition"> {{client.id_negociateur}} - {{client.negociateur.company}}</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" filterable v-if="edition" v-model="client.id_negociateur" placeholder="Pas de négociateur rattaché">
                <el-option
                  label="Pas de négociateur rattaché"
                  :value="null">
                </el-option>
                <el-option
                  v-for="item in client.all_clients"
                  :key="item.cid"
                  :label="item.company"
                  :value="Number(item.cid)">
                </el-option>
              </el-select>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Enseigne :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition" > {{client.company}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition" >
                <el-input v-on:blur="checkIfEmpty()" v-model="client.company"/>
                <transition name="fade">
                  <div v-if="MissingInput.company" class="alert alert-danger alert-missing" role="alert">
                    L'enseigne est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Commercial :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact && (!edition || rid==2)"> {{client.contact.user.firstname}} {{client.contact.user.lastname}}</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition && rid==1" v-model="client.coid" placeholder="Pas de commercial rattaché">
                <el-option
                  label="Pas de commercial rattaché"
                  :value="null">
                </el-option>
                <el-option
                  v-for="item in client.all_contact"
                  :key="item.coid"
                  :label="item.firstname+' '+item.lastname"
                  :value="Number(item.coid)">
                </el-option>
              </el-select>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Type de compte :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition" > {{client.type_de_compte}}</div> 
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition" v-model="client.type_client" placeholder="Type de compte">
                <el-option
                  v-for="item in client.all_nature_client"
                  :key="item.ncid"
                  :label="item.nom"
                  :value="Number(item.ncid)">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Dernière cmd :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> {{client.last_cmd_parsed}}</div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Etat comptable :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> <span :class="etatcomptable">{{client.etat_comptable}}</span></div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Montant débit :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> <span :class="etatcomptable">{{client.situation_comptable}}</span></div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">SIRET :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.siret}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition">
                <el-input v-on:blur="checkIfEmpty()" v-model="client.siret"/>
                <transition name="fade">
                  <div v-if="MissingInput.siret" class="alert alert-danger alert-missing" role="alert">
                    Le SIRET est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Mot de passe :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> **********</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition">
              <el-input type="password" show-password v-model="client.user.password_to_hash"/><br>
              <span style="font-size:12px">Laissez vide pour ne pas modifier</span>
              </div>
            </div>
          </div>
        </div>
        <!-- /INFORMATIONS -->
        <div class="row mt-3 text-center d-flexflex-wrap">
          <div class="information-line-name mr-3">
            Commentaire :
          </div>
          <div class="flex-grow-1">
            <el-input type="textarea" :rows="5" :disabled="!edition" v-model="client.commentaire"/>
          </div>
        </div>
        <!-- COORDONNEES -->
        <hr data-content="Coordonnées" class="hr-text">
        <div class="row">
          <div class="col-lg-4 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Adresse :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.address}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition" >
                <el-input v-on:blur="checkIfEmpty()" v-model="client.address"/>
                <transition name="fade">
                  <div v-if="MissingInput.address" class="alert alert-danger alert-missing" role="alert">
                    L'adresse est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Ville :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact && !edition"> {{client.city}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact && edition" >
                <el-input v-on:blur="checkIfEmpty()" v-model="client.city"/>
                <transition name="fade">
                  <div v-if="MissingInput.city" class="alert alert-danger alert-missing" role="alert">
                    La ville est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Code postal :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.zipcode}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition" >
                <el-input v-on:blur="checkIfEmpty()" v-model="client.zipcode"/>
                <transition name="fade">
                  <div v-if="MissingInput.zipcode" class="alert alert-danger alert-missing" role="alert">
                    Le code postal est manquant.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Pays :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.country}}</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" filterable v-if="edition" v-model="client.country" placeholder="Pays">
                <el-option
                  v-for="item in countries"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-lg-4 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Contact Princ :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.user.firstname}} {{client.user.lastname}}</div>
              <div class="my-1 information-line-text col-xl-4 col-md-4 col-sm-4" v-if="edition" >
                <el-input v-on:blur="checkIfEmpty()" v-model="client.user.firstname"/>
                <transition name="fade">
                  <div v-if="MissingInput.userFirstname" class="alert alert-danger alert-missing" role="alert">
                    Le prénom ne peut être vide.
                  </div>
                </transition>
              </div>
              <div class="my-1 information-line-text col-xl-4 col-md-3 col-sm-4" v-if="edition">
                <el-input  v-on:blur="checkIfEmpty()" v-model="client.user.lastname"/>
                <transition name="fade">
                  <div v-if="MissingInput.userLastname" class="alert alert-danger alert-missing" role="alert">
                    Le nom ne peut être vide.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Fonction :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.fonction_contact_princ}}</div>
              <el-input class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition" v-model="client.fonction_contact_princ"/>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Téléphone :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.user.phone}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition">
                <el-input  v-on:blur="checkIfEmpty()" v-model="client.user.phone"/>
                <transition name="fade">
                  <div v-if="MissingInput.phone" class="alert alert-danger alert-missing" role="alert">
                    Le téléphone ne peut être vide.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Mail :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="!edition"> {{client.user.email}}</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="edition">
                <el-input  v-on:blur="checkIfEmpty();ValidateEmail()" v-model="client.user.email"/>
                <transition name="fade">
                  <div v-if="MissingInput.email" class="alert alert-danger alert-missing" role="alert">
                    Le mail ne peut être vide.
                  </div>
                </transition>
                <transition name="fade">
                  <div v-if="badMail" class="alert alert-danger alert-missing" role="alert">
                    L'adresse mail n'est pas valide.
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="col-lg-4 client_block" >
            <div class="row" >
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Contact 2 :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && !edition"> {{client.contact2.firstname}} {{client.contact2.lastname}}</div>
              <el-input class="my-1 information-line-text col-xl-4 col-md-4 col-sm-4" v-if="edition" v-model="client.contact2.firstname"/>
              <el-input class="my-1 information-line-text col-xl-4 col-md-3 col-sm-5" v-if="edition" v-model="client.contact2.lastname"/>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Fonction :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && !edition"> {{client.contact2.name_fonction_principal}}</div>
              <el-input class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && edition" v-model="client.contact2.name_fonction_principal"/>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Téléphone :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && !edition"> {{client.contact2.phone}}</div>
              <el-input class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && edition" v-model="client.contact2.phone"/>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Mail :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && !edition"> {{client.contact2.email}}</div>
              <el-input class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-if="client.contact2 && edition" v-model="client.contact2.email"/>
            </div>
          </div>
        </div>
        <!-- /COORDONNEES -->
        <!-- CHIFFRES -->
        <hr data-content="Chiffres" class="hr-text">
        <div class="row">
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">CA N :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> {{client.ca_n}} €</div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">CA N-1 :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> {{client.ca_last_n}} €</div>
            </div>
          </div>
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Panier Moyen N :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> {{client.avg_n}} €</div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Panier Moyen N-1 :</div>
              <div class="my-2 information-line-text col-xl-8 col-md-7 col-sm-8"> {{client.avg_last_n}} €</div>
            </div>
          </div>
        </div>
        <!-- /CHIFFRES -->
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Button, ButtonGroup, Option, Select, Input} from 'element-ui'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import VueJwtDecode from 'vue-jwt-decode'
  import Country from './country'
  Vue.use(Button)
  Vue.use(ButtonGroup)
  Vue.use(Option)
  Vue.use(Select)
  Vue.use(Input)
  export default {
    components: {
      Loading
    },
    props: {

    },
    computed: {
      
    },
    data() {
      return {
        isLoading: true,
        cid: this.$route.params.cid,
        client: [],
        edition: false,
        rid: VueJwtDecode.decode(localStorage.getItem('token')).id.rid,
        countries: Country,
        MissingInput: {
          company: 0,
          siret: 0,
          address: 0,
          city: 0,
          zipcode: 0,
          userFirstname: 0,
          userLastname: 0,
          phone: 0,
          email: 0,
        },
        badMail: 0
      }
    },
    computed: {
      etatcomptable() {
        if(this.client.etat_comptable != "OK") {
          return "text-danger"
        } else {
          return "text-success"
        }
      }
    },
    methods: {
      changeEdition() {
        if(this.edition === true) {
          this.edition = false;
        } else {
          this.edition = true;
        }
      },
      async saveClient() {
        if(this.checkIfEmpty()) {
          this.notifyVue('top','center', 'danger', 'Il manque des champs obligatoire! 😱', 'fa fa-thumbs-down')
          return; 
        }
        if(this.ValidateEmail()) {
          this.notifyVue('top','center', 'danger', 'L\'email n\'est pas valide! 😱', 'fa fa-thumbs-down')
          return; 
        }
        this.loading = true;
        let client_to_put = this.client;
        delete client_to_put['all_clients']
        delete client_to_put['adresses']
        delete client_to_put['all_nature_client']
        delete client_to_put['all_contact']
        delete client_to_put['orders']
        delete client_to_put['categories']
        const params = this.JSON_to_URLEncoded(client_to_put);
        // const params = Object.keys(this.client).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.client[key])).join('&');

        const response = await fetch(this.$api_url+'/clients', {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: params
        });
        const self = this;
        const json = await response.json();
        if("rows" in json) {
          self.log_api("success",'PUT /clients',params, json)
          console.log(json)
          //SUCCESS PUT CLIENT
          const params = this.JSON_to_URLEncoded(this.client.user);
          const response = await fetch(this.$api_url+'/users', {
            method: 'PUT',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: params
          });
          const json2 = await response.json();
          if("rows" in json2) {
            self.log_api("success",'PUT /users',params, json2)
            //SUCCESS PUT USER
            this.notifyVue('top','center', 'success', 'Client modifié! 😄', 'fa fa-thumbs-up')
            this.getClient();
            this.edition = false;
          } else {
            self.log_api("error",'PUT /users',params, json2)
            //ERROR PUT USER
            this.notifyVue('top','center', 'danger', 'Problème lors de la modification! 😱', 'fa fa-thumbs-down')
          } 
        } else {
          self.log_api("error",'PUT /clients',params, json)
          //ERROR PUT CLIENT
          this.notifyVue('top','center', 'danger', 'Problème lors de la modification! 😱', 'fa fa-thumbs-down')
        } 
        this.loading = false;
      },
      async cancel() {
        this.isLoading = true
        this.getClient();
        this.edition = false;
      },
      async getClient() {
        const self = this;
        const response = await fetch(this.$api_url+'/clients/'+this.cid, {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          if(json.code != 409) {
            self.log_api("success",'GET /clients/'+self.cid, '', json)
            json.etat_comptable = json.situation_comptable != "" ? "Débiteur" : "OK" 
            this.client = json
          }
        }
        this.isLoading = false
      },
      notifyVue (verticalAlign, horizontalAlign, color, message, icon) {
        this.$notify(
          {
            message: message,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: color
          })
      },
      JSON_to_URLEncoded(obj, prefix) {
        var str = [],
          p;
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
              v = obj[p];
            str.push((v !== null && typeof v === "object") ?
              this.JSON_to_URLEncoded(v, k) :
              encodeURIComponent(k) + "=" + encodeURIComponent(v));
          }
        }
        return str.join("&");
      },
      checkIfEmpty() {
        this.MissingInput.company = (this.client.company == "" ? 1 : 0)
        this.MissingInput.siret = (this.client.siret == "" ? 1 : 0)
        this.MissingInput.address = (this.client.address == "" ? 1 : 0)
        this.MissingInput.city = (this.client.city == "" ? 1 : 0)
        this.MissingInput.zipcode = (this.client.zipcode == "" ? 1 : 0)
        this.MissingInput.userFirstname = (this.client.user.firstname == "" ? 1 : 0)
        this.MissingInput.userLastname = (this.client.user.lastname == "" ? 1 : 0)
        this.MissingInput.phone = (this.client.user.phone == "" ? 1 : 0)
        this.MissingInput.email = (this.client.user.email == "" ? 1 : 0)

        let isOneMissing = 0
        for(const key of Object.keys(this.MissingInput)) {
          if(this.MissingInput[key] == 1) {
            isOneMissing = 1
          }
        }
        return isOneMissing;
      },
      ValidateEmail() {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.client.user.email)) {
          this.badMail = 0
          return (false)
        }
        this.badMail = 1
        return (true)
      }
    },
    created() {
      this.getClient()
    },
  }
</script>

<style lang="scss">
  .nom_company {
    font-size:20px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .header_client_link {
    text-transform: uppercase;
    text-decoration: underline;
    font-weight: bold;
    word-break: break-word;
    overflow-x: break-word;
    padding:10px
  }
  .active {
    color:black;
  }
  .header_client_link:last-child {
    margin-right:0
  }
  .btn-action {
    font-size:20px
  }
  hr {
    margin-top:30px
  }
  hr.hr-text {
    position: relative;
    border: none;
    height: 1px;
    background: rgb(223, 223, 223);
  }
  hr.hr-text::before {
    content: attr(data-content);
    display: inline-block;
    background: #fff;
    font-weight: bold;
    font-size: 1rem;
    color: black;
    border-radius: 30rem;
    padding: 0.2rem 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .information-line-name {
    text-transform: uppercase;
    font-weight: bold;
    line-height:30px
  }
  .information-line-text {
    line-height:30px
  }
  .client_block {
    border-right: 1px solid rgb(223, 223, 223);
  }
  .client_block:last-child {
    border-right: 0px solid rgb(223, 223, 223); 
  }
  .el-textarea.is-disabled .el-textarea__inner {
    color:black;
  }
</style>
